(() => {
  const dialog = document.getElementById('signup-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'pt-signup-dismissed-v1';
  let opener = null;
  let dismissed = false;
  let timer = null;
  const remember = () => { dismissed = true; try { localStorage.setItem(key, '1'); } catch (_) { try { sessionStorage.setItem(key, '1'); } catch (_) {} } };
  const hasDismissed = () => { try { if (localStorage.getItem(key)) return true; } catch (_) {} try { return Boolean(sessionStorage.getItem(key)); } catch (_) { return dismissed; } };
  const open = trigger => {
    clearTimeout(timer);
    if (dialog.open) return;
    const menu = document.getElementById('mobile-nav');
    if (menu && !menu.hidden) document.querySelector('[data-menu-toggle]')?.click();
    opener = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('signup-popup-open');
    (dialog.querySelector('[data-signup-result="success"]') || dialog.querySelector('#signup-title'))?.focus({ preventScroll: true });
  };
  window.PTSignup = { open };
  dialog.querySelectorAll('[data-signup-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('cancel', () => remember());
  dialog.addEventListener('close', () => {
    remember();
    document.documentElement.classList.remove('signup-popup-open');
    if (opener?.isConnected && opener !== document.body) opener.focus({ preventScroll: true });
  });
  const form = dialog.querySelector('form');
  form?.addEventListener('submit', () => { try { sessionStorage.setItem('pt-signup-pending', '1'); } catch (_) {} });
  let pending = false;
  try { pending = Boolean(sessionStorage.getItem('pt-signup-pending')); } catch (_) {}
  const result = dialog.querySelector('[data-signup-result]');
  if (result && (pending || location.hash === '#popup-newsletter')) {
    try { sessionStorage.removeItem('pt-signup-pending'); } catch (_) {}
    if (result.dataset.signupResult === 'success') remember();
    open();
  } else if (!hasDismissed() && dialog.dataset.subscribed !== 'true' && !window.Shopify?.designMode) {
    timer = setTimeout(() => {
      if (!hasDismissed() && !document.querySelector('dialog[open], .drawer.is-open, #mobile-nav.is-open')) open();
    }, 1200);
  }
})();
